// ============================================
// ROOMS SECTION - Shrileela Beach Resort
// ============================================

import { useState } from "react";
import { roomTypes } from '../../data/shreeData';

const RoomsSection = ({ onBookRoom }) => {
  const [currentSlide, setCurrentSlide] = useState({});

  const getSlide = (roomId) => currentSlide[roomId] || 0;

  const prevSlide = (e, roomId, total) => {
    e.stopPropagation();
    setCurrentSlide(prev => ({
      ...prev,
      [roomId]: (getSlide(roomId) - 1 + total) % total
    }));
  };

  const nextSlide = (e, roomId, total) => {
    e.stopPropagation();
    setCurrentSlide(prev => ({
      ...prev,
      [roomId]: (getSlide(roomId) + 1) % total
    }));
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Jost:wght@300;400;500;600&display=swap');

        .rooms-section {
          padding: 100px 24px 20px 24px;
          background: #fff;
          font-family: 'Jost', sans-serif;
        }
        .rooms-inner { max-width: 1200px; margin: 0 auto; }
        .rooms-header { text-align: center; margin-bottom: 64px; }
        .rooms-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 28px;
          margin-bottom: 64px;
        }

        /* ── Base Room Card ── */
        .room-card {
          border-radius: 20px;
          overflow: hidden;
          border: 1.5px solid #eee;
          transition: all 0.4s ease;
          background: #fff;
          position: relative;
        }
        .room-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.1);
          border-color: #c8dcc8;
        }

        /* ── Suite Card Gold Styling ── */
        .room-card.suite {
          border-color: #d4b875;
          background: linear-gradient(180deg, #fffdf5 0%, #fff 40%);
        }
        .room-card.suite:hover {
          box-shadow: 0 20px 60px rgba(139,105,20,0.15);
          border-color: #b8922a;
        }
        .room-card.suite .room-name { color: #6b4e10; }
        .room-card.suite:hover .room-name { color: #8B6914; }
        .room-card.suite .room-price { color: #8B6914; }
        .room-card.suite .amenity-check { color: #8B6914; }
        .room-card.suite .room-book-btn {
          background: linear-gradient(135deg, #8B6914, #6b4e10);
        }
        .room-card.suite .room-book-btn:hover {
          background: linear-gradient(135deg, #6b4e10, #4a3408);
          box-shadow: 0 8px 24px rgba(139,105,20,0.35);
        }
        .room-card.suite .room-avail {
          background: rgba(139,105,20,0.85);
        }

        /* Suite crown ribbon */
        .suite-ribbon {
          position: absolute;
          top: 0; right: 0;
          background: linear-gradient(135deg, #8B6914, #c9a227);
          color: #fff;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          padding: 6px 18px 6px 12px;
          border-bottom-left-radius: 14px;
          z-index: 3;
        }

        /* ── Image Slider ── */
        .room-img-wrap {
          position: relative;
          height: 240px;
          overflow: hidden;
        }
        .room-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }
        .room-card:hover .room-img { transform: scale(1.07); }
        .room-img-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 50%);
          pointer-events: none;
        }
        .room-badge {
          position: absolute;
          top: 16px;
          left: 16px;
          background: rgba(255,255,255,0.95);
          padding: 5px 14px;
          border-radius: 40px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.5px;
          z-index: 2;
        }
        .room-avail {
          position: absolute;
          top: 16px;
          right: 16px;
          background: rgba(61,90,62,0.9);
          color: #fff;
          padding: 5px 12px;
          border-radius: 40px;
          font-size: 11px;
          font-weight: 500;
          z-index: 2;
        }

        /* Slider arrows */
        .slider-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.85);
          border: none;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
          z-index: 3;
          transition: background 0.2s;
          line-height: 1;
        }
        .slider-arrow:hover { background: #fff; }
        .slider-arrow.prev { left: 10px; }
        .slider-arrow.next { right: 10px; }

        /* Dots */
        .slider-dots {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 5px;
          z-index: 3;
        }
        .slider-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.2s, transform 0.2s;
        }
        .slider-dot.active {
          background: #fff;
          transform: scale(1.3);
        }

        /* Slide counter */
        .slide-counter {
          position: absolute;
          bottom: 10px;
          right: 14px;
          background: rgba(0,0,0,0.45);
          color: #fff;
          font-size: 10px;
          font-weight: 500;
          padding: 2px 8px;
          border-radius: 20px;
          z-index: 3;
        }

        .room-body { padding: 24px; }
        .room-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 12px;
          gap: 12px;
        }
        .room-name {
          font-family: 'Playfair Display', serif;
          font-size: 22px;
          font-weight: 700;
          color: #1a2b1a;
          line-height: 1.2;
          flex: 1;
          transition: color 0.2s;
        }
        .room-card:hover .room-name { color: #3d5a3e; }
        .room-price-wrap { text-align: right; flex-shrink: 0; }
        .room-price { font-size: 26px; font-weight: 700; color: #3d5a3e; line-height: 1; }
        .room-per { font-size: 11px; color: #999; }
        .room-desc { font-size: 14px; color: #666; line-height: 1.7; margin-bottom: 16px; font-weight: 300; }
        .room-guests { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #888; margin-bottom: 18px; }

        .room-amenities {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6px;
          margin-bottom: 20px;
        }
        .room-amenity {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12.5px;
          color: #555;
        }
        .amenity-check { color: #3d5a3e; font-weight: 700; }

        .room-card.suite .room-amenity { color: #6b4e10; }
        .room-amenity-more {
          font-size: 12px;
          color: #8B6914;
          font-weight: 600;
          padding: 2px 0;
          grid-column: span 2;
        }

        .room-book-btn {
          width: 100%;
          background: #3d5a3e;
          color: #fff;
          border: none;
          padding: 14px;
          border-radius: 12px;
          font-family: 'Jost', sans-serif;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0.5px;
          cursor: pointer;
          transition: all 0.25s;
        }
        .room-book-btn:hover {
          background: #2d4230;
          box-shadow: 0 8px 24px rgba(61,90,62,0.3);
        }

        @media (max-width: 900px) {
          .rooms-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 500px) {
          .room-amenities { grid-template-columns: 1fr; }
          .room-amenity-more { grid-column: span 1; }
        }

        .section-eyebrow {
          display: inline-block;
          background: #e8f0e8;
          color: #3d5a3e;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          padding: 6px 18px;
          border-radius: 40px;
          margin-bottom: 20px;
        }
        .section-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 700;
          color: #1a2b1a;
          margin: 0 0 16px;
          line-height: 1.15;
        }
        .section-subtitle {
          font-size: 17px;
          color: #666;
          font-weight: 300;
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.7;
        }
      `}</style>

      <section id="rooms" className="rooms-section">
        <div className="rooms-inner">
          <div className="rooms-header">
            <span className="section-eyebrow">Accommodations</span>
            <h2 className="section-title">Our Rooms & Stay Options</h2>
            <p className="section-subtitle">Comfortable, affordable rooms just steps from Murud Beach</p>
          </div>

          <div className="rooms-grid">
            {roomTypes.map(room => {
              const isSuite = room.id === 2;
              const images = room.images || [];
              const slideIdx = getSlide(room.id);

              return (
                <div key={room.id} className={`room-card${isSuite ? " suite" : ""}`}>

                  <div className="room-img-wrap">
                    {/* Slider image */}
                    <img
                      src={images[slideIdx]}
                      alt={`${room.name} - ${slideIdx + 1}`}
                      className="room-img"
                    />
                    <div className="room-img-overlay" />

                    {/* Arrows (only if more than 1 image) */}
                    {images.length > 1 && (
                      <>
                        <button className="slider-arrow prev" onClick={e => prevSlide(e, room.id, images.length)}>‹</button>
                        <button className="slider-arrow next" onClick={e => nextSlide(e, room.id, images.length)}>›</button>

                        {/* Dots */}
                        <div className="slider-dots">
                          {images.map((_, i) => (
                            <button
                              key={i}
                              className={`slider-dot${i === slideIdx ? " active" : ""}`}
                              onClick={e => { e.stopPropagation(); setCurrentSlide(prev => ({ ...prev, [room.id]: i })); }}
                            />
                          ))}
                        </div>

                        {/* Counter */}
                        <div className="slide-counter">{slideIdx + 1} / {images.length}</div>
                      </>
                    )}

                    <div className="room-badge" style={{ color: room.badgeColor }}>{room.badge}</div>
                    <div className="room-avail">{room.available} Available</div>
                  </div>

                  <div className="room-body">
                    <div className="room-head">
                      <div className="room-name">{room.name}</div>
                      <div className="room-price-wrap">
                        <div className="room-price">₹{room.price.toLocaleString()}</div>
                        <div className="room-per">per night</div>
                      </div>
                    </div>

                    <p className="room-desc">{room.description}</p>

                    <div className="room-guests">
                      <span>👥</span>
                      <span>Max {room.maxGuests} Guests</span>
                    </div>

                    <div className="room-amenities">
                      {room.amenities.slice(0, 4).map((a, i) => (
                        <div key={i} className="room-amenity">
                          <span className="amenity-check">✓</span>
                          <span>{a}</span>
                        </div>
                      ))}
                      {room.amenities.length > 4 && (
                        <div className="room-amenity-more">
                          + {room.amenities.length - 4} more amenities included
                        </div>
                      )}
                    </div>

                    <button className="room-book-btn" onClick={() => onBookRoom(room)}>
                      {isSuite ? "👑 Book Suite →" : "Book This Room →"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default RoomsSection;